export default __webpack_public_path__ + "static/media/seguro.e928f174.png";